import {Pipe, PipeTransform} from '@angular/core';
import {I18nServices} from "../i18n/i18n.service";
import {ProductService} from "../product/product.service";

@Pipe({
    name: 'formatcrypto',
    standalone: false
})
export class FormatCryptoPipe implements PipeTransform {

  constructor(protected productService: ProductService,
              protected i18nService: I18nServices) {

  }

  public async transform(value: number, symbol = null, showDecimals = true) {

    if(value == null) {
      return "-";
    }

    if(symbol != null) {
      if(value == 0) {
        return value.toString();
      }
      else {
        let crypto = await this.productService.getProduct(symbol);
        if (crypto != null) {
          return this.i18nService.formatNumber(value, crypto.precision);
        } else {
          return value.toString();
        }
      }
    }
    else {
      return value.toString();
    }

  }

}


